// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".profit-share-dialog .el-dialog__body {\n  padding: 5px !important;\n}\n.profit-share-dialog .el-dialog__body .el-form-item {\n    margin-bottom: 0 !important;\n}\n", ""]);
// Exports
module.exports = exports;
